import {
  Building2, ChefHat, Refrigerator, Microwave, Plug, Castle, Joystick,
  Gamepad2, Target, Zap, Car, Utensils, CupSoda, Coffee, UtensilsCrossed,
  Grab, Circle, Candy, Sparkles,
} from "lucide-react";

const MAP = {
  Building2, ChefHat, Refrigerator, Microwave, Plug, Castle, Joystick,
  Gamepad2, Target, Zap, Car, Utensils, CupSoda, Coffee,
  Plate: UtensilsCrossed, Fork: Utensils, Grab, Circle, Candy,
};

export function getIcon(name) {
  return MAP[name] || Sparkles;
}
